<template>
  <div>
    <label class="label" v-if="label !== undefined" :for="name">{{label}}</label>
    <textarea @input="input"
              :id="name"
              :name="name"
              :class="{'invalid' : error !== undefined}"
              :placeholder="placeholder"
              class="input"
              :value="value"
    >
    </textarea>
  </div>
</template>

<script>
  import inputMixin from '../../mixins/inputMixin';

  export default {
    name: "InputTextarea",
    mixins: [inputMixin]
  }
</script>

<style>
  textarea {
    min-height: 167px;
    resize: none;
  }
</style>